import { createStore, combineReducers, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import redmineAggregatedDataReducer from './reducers/redmineAggregatedDataReducer';

const rootReducer = combineReducers({
  redmineAggregatedData: redmineAggregatedDataReducer,
});

const store = createStore(
  rootReducer,
  applyMiddleware(thunk)
);

export default store;
